angular.module("vgresiduos").controller("GoBackButtonCtrl", [
	function () {
		"use strict";
	}
]);
